<div>
	<strong class="text-danger" *ngIf="showValidation && isControlInvalid">
		Please upload an image.
	</strong>

	<strong class="text-danger" *ngIf="uploadError">
		There was an error uploading your image.
	</strong>

	<strong class="text-success" *ngIf="success">
		Successfully uploaded document
	</strong>
</div>
<br />

<div>
	<label for="upload" class="btn btn-{{ buttonContext }}">
		<span *ngIf="!uploading">
			{{ buttonLabel }}
		</span>
		<span *ngIf="uploading" class="text-center">
			<i class="fa fa-spinner fa-spin"></i>
		</span>
	</label>

	<input
		id="upload"
		#fileUpload
		style="display: none;"
		class="btn btn-success"
		type="file"
		(change)="onFileChange($event)"
		[accept]="acceptableFiles"
	/>
</div>

<br />

<div>
	<img [src]="imgSrc" alt="" class="img-responsive" />
</div>
